import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: false,
  API_PREFIX: 'https://api.phoenix-garden.com',
  SOCKET_PREFIX: 'wss://api.phoenix-garden.com',
}
